import { z } from "zod";

import { api } from "~/api";
import { userAppointmentsResponseSchema, VISIT_TYPES } from "../scheduling";
import {
  bookingProvidersResponseSchema,
  cancelReasonSchema,
  editVisitCancellationResponseSchema,
} from "./schemas";
import {
  BookingProvidersParams,
  CancelReasonType,
  CancelVisitData,
  EditVisitCancellationData,
} from "./types";

export const getCancelReasons = async ({
  type,
}: {
  type?: CancelReasonType;
}) => {
  const response = await api.get("appointments/cancel-reasons", {
    params: { type },
  });
  return z.array(cancelReasonSchema).parse(response.data.data);
};

export const getBookingProviders = async ({
  stateId,
  insuranceId,
  userId,
}: BookingProvidersParams) => {
  const response = await api.get(`admin/users/${userId}/follow-up-providers`, {
    params: {
      state_id: stateId,
      appointment_type: VISIT_TYPES.FOLLOW_UP,
      insurance_id: insuranceId,
    },
  });
  return bookingProvidersResponseSchema.parse(response.data).data;
};

export const cancelVisit = async (cancelVisitData: CancelVisitData) => {
  const response = await api.post("admin/appointments/cancel", {
    appointment_id: cancelVisitData.appointmentId,
    patient_id: cancelVisitData.patientId,
    appointment_cancel_reason_id:
      cancelVisitData.cancelReasonChildId ||
      cancelVisitData.cancelReasonParentId,
    cancellation_notes: cancelVisitData.cancellationNotes,
    waive_fee: cancelVisitData.waiveFee,
  });
  return z
    .object({ status: z.number(), success: z.boolean() })
    .parse(response.data);
};

export const editVisitCancellation = async ({
  ehrAppointmentId,
  ...data
}: EditVisitCancellationData) => {
  const response = await api.patch(
    `admin/appointments/${ehrAppointmentId}/cancellation`,
    {
      appointment_cancel_reason_id:
        data.cancelReasonChildId || data.cancelReasonParentId,
      cancellation_notes: data.cancellationNotes,
      waive_fee: data.waiveFee,
    },
  );

  return editVisitCancellationResponseSchema.parse(response.data.data);
};

export const getAppointments = async (userId: string) => {
  const response = await api.get(`admin/users/${userId}/appointments`);
  return userAppointmentsResponseSchema.parse(response.data.data);
};

export const syncEmailEnteredToPaubox = async (data: {
  email: string;
  stateId: number;
  insuranceId: number;
}) => {
  await api.post("admin/email-entered", {
    email: data.email,
    state_id: data.stateId,
    insurance_id: data.insuranceId,
  });
};
